import {
  actions,
  getComponentByIdAsync,
  getAllowedComponentsForCollectionComponentTypeAsync,
  getComponentLookupsAsync,
  getComponentLookupsByComponentTypeIdsAsync,
  createComponentByTypeIdAsync,
  editComponentAsync,
  cloneComponentAsync,
  getComponentComponentLookupsAsync,
  getComponentPageBodyLookupsAsync,
  getComponentsDatatableAsync,
  getComponentByIdMultilingualAsync,
  createComponentByTypeIdMultilingualAsync,
  editComponentMultilingualAsync,
} from './slices';

export const ComponentsActions = {
  ...actions,
  getComponentByIdAsync,
  getAllowedComponentsForCollectionComponentTypeAsync,
  getComponentLookupsAsync,
  getComponentLookupsByComponentTypeIdsAsync,
  createComponentByTypeIdAsync,
  editComponentAsync,
  cloneComponentAsync,
  getComponentComponentLookupsAsync,
  getComponentPageBodyLookupsAsync,
  getComponentsDatatableAsync,
  getComponentByIdMultilingualAsync,
  createComponentByTypeIdMultilingualAsync,
  editComponentMultilingualAsync,
};

export * from './thunkHandlers';
